import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * « Renvoyer au puits » : les lignes quittent leur date (et leur camion) et
 * redeviennent des lignes du puits de commandes
 */
const useReturnToPool = () => {
  const [isReturning, setIsReturning] = useState(false);

  const returnToPool = useCallback(async (tourPlanningIds) => {
    setIsReturning(true);
    try {
      const response = await fleetApi.post(
        '/tours-planning/steps/return-to-pool',
        { tour_planning_ids: tourPlanningIds }
      );
      return response.data?.data || { returnedCount: 0 };
    } catch (err) {
      throw new Error(
        err?.response?.data?.message ||
          err.message ||
          'Impossible de renvoyer les lignes au puits'
      );
    } finally {
      setIsReturning(false);
    }
  }, []);

  return { returnToPool, isReturning };
};

export default useReturnToPool;
